<!--eslint-disable-->
<template>
    <div>
        <el-form :model="form" size='mini' label-width='150px'>
            <el-form-item label='Ticker'>
                <el-select v-model="form.ticker" placeholder='Selecione a ação' @change="onChange" autocomplete>
                    <el-option
                    v-for="item in tableData"
                    :key="item.ticker"
                    :label='item.ticker'
                    :value='item.ticker'>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label='Empresa'>
                <el-input v-model="form.empresa" style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item label='Setor'>
                <el-input v-model="form.setor" style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item label='Cobertura'>
                <el-input v-model="form.cobertura" style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item label='Target Price Leblon'>
                <el-input v-model="form.tp_leblon" style="width: 200px"></el-input>
            </el-form-item>
            <el-collapse>
                <el-collapse-item title='Qualidade' name='1'>
                    <el-form-item label='Acionistas'>
                        <el-radio-group v-model="form.acionistas">
                            <el-radio label='1'></el-radio>
                            <el-radio label='2'></el-radio>
                            <el-radio label='3'></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label='Conselho'>
                        <el-radio-group v-model="form.conselho">
                            <el-radio label='1'></el-radio>
                            <el-radio label='2'></el-radio>
                            <el-radio label='3'></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label='Management'>
                        <el-radio-group v-model="form.management">
                            <el-radio label='1'></el-radio>
                            <el-radio label='2'></el-radio>
                            <el-radio label='3'></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label='Cultura'>
                        <el-radio-group v-model="form.cultura">
                            <el-radio label='1'></el-radio>
                            <el-radio label='2'></el-radio>
                            <el-radio label='3'></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label='Estratégia'>
                        <el-radio-group v-model="form.estrategia">
                            <el-radio label='1'></el-radio>
                            <el-radio label='2'></el-radio>
                            <el-radio label='3'></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label='Dinâmica Setorial'>
                        <el-radio-group v-model="form.dinamicaSetorial">
                            <el-radio label='1'></el-radio>
                            <el-radio label='2'></el-radio>
                            <el-radio label='3'></el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-collapse-item>
                <el-collapse-item title='Valuation LTM'>
                    <el-form-item label='P/FCF LTM'>
                        <el-input v-model="form.p_fcf_ltm" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label='EV/OpFCF LTM'>
                        <el-input v-model="form.ev_opfcf_ltm" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label='P/CE LTM'>
                        <el-input v-model="form.p_ce_ltm" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label='P/E LTM'>
                        <el-input v-model="form.p_e_ltm" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label='Dividend Yield LTM'>
                        <el-input v-model="form.dividend_yield_ltm" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label='P/Book LTM'>
                        <el-input v-model="form.p_book_ltm" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label='EV/Sales LTM'>
                        <el-input v-model="form.ev_sales_ltm" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label='EV/EBITDA LTM'>
                        <el-input v-model="form.ev_ebitda_ltm" style="width: 200px"></el-input>
                    </el-form-item>
                </el-collapse-item>
                <el-collapse-item title='Valuation NTM'>
                    <el-form-item label='P/FCF NTM'>
                        <el-input v-model="form.p_fcf_ntm" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label='P/E NTM'>
                        <el-input v-model="form.p_e_ntm" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label='Dividend Yield NTM'>
                        <el-input v-model="form.dividend_yield_ntm" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label='P/Book NTM'>
                        <el-input v-model="form.p_book_ntm" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label='EV/Sales NTM'>
                        <el-input v-model="form.ev_sales_ntm" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label='EV/EBITDA NTM'>
                        <el-input v-model="form.ev_ebitda_ntm" style="width: 200px"></el-input>
                    </el-form-item>
                </el-collapse-item>
            </el-collapse>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">Salvar</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
/* eslint-disable */
import fb from '@/services/firebaseConfig'
import firebase from 'firebase/app'
const db = fb.db

  export default {
    data() {
      return {
        weight: {
            acionistas: 0.05,
            conselho: 0.05,
            management: 0.05,
            cultura: 0.05,
            estrategia: 0.05,
            dinamicaSetorial: 0.05
        },
        fileListQuality: [],
        tableData: [],
        form: {

        }
      }
    },
    computed: {
        coverageFilters() {
            return this.filterFunction('cobertura')
        },
        setComputedProperties(){}
    },
    methods: {
        colorCriterium({row, column}) {
            if (row[column.property] == 1) return "green-row"
            else if (row[column.property] == 2) return "yellow-row"
            else if (row[column.property] == 3) return "red-row"
            else return
        },
        editCompany(scope) {
            this.form = {
                ticker: scope.ticker,
                empresa: scope.empresa,
                setor: scope.setor,
                cobertura: scope.cobertura,
                acionistas: scope.acionistas,
                conselho: scope.conselho,
                management: scope.management,
                cultura: scope.cultura,
                estrategia: scope.estrategia,
                dinamicaSetorial: scope.dinamicaSetorial,
                tp_leblon: scope.tp_leblon,
                p_fcf_ltm: scope.p_fcf_ltm,
                ev_opfcf_ltm: scope.ev_opfcf_ltm,
                p_ce_ltm: scope.p_ce_ltm,
                p_e_ltm: scope.p_e_ltm,
                dividend_yield_ltm: scope.dividend_yield_ltm,
                p_book_ltm: scope.p_book_ltm,
                ev_sales_ltm: scope.ev_sales_ltm,
                ev_ebitda_ltm: scope.ev_ebitda_ltm,
                p_fcf_ntm: scope.p_fcf_ntm,
                p_e_ntm: scope.p_e_ntm,
                dividend_yield_ntm: scope.dividend_yield_ntm,
                p_book_ntm: scope.p_book_ntm,
                ev_sales_ntm: scope.ev_sales_ntm,
                ev_ebitda_ntm: scope.ev_ebitda_ntm,
            }
        },
        async onSubmit() {
            let docRef = db.collection('monitoringCompanies').doc(this.form.ticker)

            // Transformar as strings em floats
            this.form.tp_leblon = this.form.tp_leblon.replace(",",".") * 1
            this.p_fcf_ltm = this.form.p_fcf_ltm.replace(",",".") * 1 
            this.ev_opfcf_ltm = this.form.ev_opfcf_ltm.replace(",",".") * 1
            this.p_ce_ltm = this.form.p_ce_ltm.replace(",",".") * 1
            this.p_e_ltm = this.form.p_e_ltm.replace(",",".") * 1
            this.dividend_yield_ltm = this.form.dividend_yield_ltm.replace(",",".") * 1
            this.p_book_ltm = this.form.p_book_ltm.replace(",",".") * 1
            this.ev_sales_ltm = this.form.ev_sales_ltm.replace(",",".") * 1
            this.ev_ebitda_ltm = this.form.ev_ebitda_ltm.replace(",",".") * 1
            this.p_fcf_ntm = this.form.p_fcf_ntm.replace(",",".") * 1
            this.p_e_ntm = this.form.p_e_ntm.replace(",",".") * 1
            this.dividend_yield_ntm = this.form.dividend_yield_ntm.replace(",",".") * 1
            this.p_book_ntm = this.form.p_book_ntm.replace(",",".") * 1
            this.ev_sales_ntm = this.form.ev_sales_ntm.replace(",",".") * 1
            this.ev_ebitda_ntm = this.form.ev_ebitda_ntm.replace(",",".") * 1

            let email = firebase.auth().currentUser['email']
            let userDoc = await db.collection('userData').doc(email).get()
            let data = userDoc.data()
            let doc = await docRef.set({
                empresa: this.form.empresa,
                setor: this.form.setor,
                cobertura: this.form.cobertura,
                acionistas: parseFloat(this.form.acionistas),
                conselho: parseFloat(this.form.conselho),
                management: parseFloat(this.form.management),
                cultura: parseFloat(this.form.cultura),
                estrategia: parseFloat(this.form.estrategia),
                dinamicaSetorial: parseFloat(this.form.dinamicaSetorial),
                tp_leblon: parseFloat(this.form.tp_leblon),
                p_fcf_ltm: parseFloat(this.form.p_fcf_ltm), 
                ev_opfcf_ltm: parseFloat(this.form.ev_opfcf_ltm),
                p_ce_ltm: parseFloat(this.form.p_ce_ltm),
                p_e_ltm: parseFloat(this.form.p_e_ltm),
                dividend_yield_ltm: parseFloat(this.form.dividend_yield_ltm),
                p_book_ltm: parseFloat(this.form.p_book_ltm),
                ev_sales_ltm: parseFloat(this.form.ev_sales_ltm),
                ev_ebitda_ltm: parseFloat(this.form.ev_ebitda_ltm),
                p_fcf_ntm: parseFloat(this.form.p_fcf_ntm),
                p_e_ntm: parseFloat(this.form.p_e_ntm),
                dividend_yield_ntm: parseFloat(this.form.dividend_yield_ntm),
                p_book_ntm: parseFloat(this.form.p_book_ntm),
                ev_sales_ntm: parseFloat(this.form.ev_sales_ntm),
                ev_ebitda_ntm: parseFloat(this.form.ev_ebitda_ntm),
                user: data['nome'],
                lastUpdate: firebase.firestore.Timestamp.now()
            }, {merge: true})

            this.$message({
                showClose: true,
                message: this.form.ticker + ' salvo com sucesso.',
                type: 'success'
            });
        },
        async onChange() {
            console.log(firebase.auth().currentUser['email'])
            let doc = await db.collection('monitoringCompanies').doc(this.form.ticker).get()
            let data = doc.data()
            this.form = {
                ticker: doc.id,
                empresa: data.empresa,
                setor: data.setor,
                cobertura: data.cobertura,
                acionistas: data.acionistas.toFixed(0),
                conselho: data.conselho.toFixed(0),
                management: data.management.toFixed(0),
                cultura: data.cultura.toFixed(0),
                estrategia: data.estrategia.toFixed(0),
                dinamicaSetorial: data.dinamicaSetorial.toFixed(0),
                tp_leblon: data.tp_leblon.toFixed(2),
                p_fcf_ltm: data.p_fcf_ltm.toFixed(2), 
                ev_opfcf_ltm: data.ev_opfcf_ltm.toFixed(2),
                p_ce_ltm: data.p_ce_ltm.toFixed(2),
                p_e_ltm: data.p_e_ltm.toFixed(2),
                dividend_yield_ltm: data.dividend_yield_ltm.toFixed(2),
                p_book_ltm: data.p_book_ltm.toFixed(2),
                ev_sales_ltm: data.ev_sales_ltm.toFixed(2),
                ev_ebitda_ltm: data.ev_ebitda_ltm.toFixed(2),
                p_fcf_ntm: data.p_fcf_ntm.toFixed(2),
                p_e_ntm: data.p_e_ntm.toFixed(2),
                dividend_yield_ntm: data.dividend_yield_ntm.toFixed(2),
                p_book_ntm: data.p_book_ntm.toFixed(2),
                ev_sales_ntm: data.ev_sales_ntm.toFixed(2),
                ev_ebitda_ntm: data.ev_ebitda_ntm.toFixed(2)
            }
            // console.log(this.form)
        },
        includesFilter(value, row, column) {
            const property = column['property']
            return row[property].includes(value)
        },
        filterFunction(prop, blank = ['', '-']) {
            let list = []
            let filters = []
            this.tableData.forEach(row => {
                list.push(row[prop])
            })
            list = [...new Set(list)].sort()
            list.forEach(each => {
                filters.push({ text: each === blank[0] ? blank[1] : each, value: each })
            })
            return filters
        },
        handleUploadQuality(file) {
            let fileReader = new FileReader()
            // fileReader.readAsBinaryString(file.file)
            fileReader.onload = () => {
                console.log(fileReader.result)
            }
        },
    },
    created() {
        db.collection('monitoringCompanies')
            .onSnapshot(
                qSnapshot => {
                    let list = []
                    qSnapshot.forEach(doc => {

                        let obj = doc.data()
                        // console.log(doc.id, "1")
                        list.push({
                            ticker: doc.id,
                            empresa: obj.empresa,
                            setor: obj.setor,
                            cobertura: obj.cobertura,
                            setor: obj.setor,
                            cobertura: obj.cobertura,
                            acionistas: obj.acionistas === undefined ? 0 : (obj.acionistas).toFixed(0),
                            conselho: obj.conselho === undefined ? 0 : (obj.conselho).toFixed(0),
                            management: obj.management === undefined ? 0 : (obj.management).toFixed(0),
                            cultura: obj.cultura === undefined ? 0 : (obj.cultura).toFixed(0),
                            estrategia: obj.estrategia === undefined ? 0 : (obj.estrategia).toFixed(0),
                            dinamicaSetorial: obj.dinamicaSetorial === undefined ? 0 : (obj.dinamicaSetorial).toFixed(0),
                            tp_leblon: isNaN(obj.tp_leblon) ? 0 : (obj.tp_leblon).toFixed(2),
                            p_fcf_ltm: isNaN(obj.p_fcf_ltm) ? 0 : (obj.p_fcf_ltm).toFixed(2),
                            ev_opfcf_ltm: isNaN(obj.ev_opfcf_ltm) ? 0 : (obj.ev_opfcf_ltm).toFixed(2),
                            p_ce_ltm: isNaN(obj.p_ce_ltm) ? 0 : (obj.p_ce_ltm).toFixed(2),
                            p_e_ltm: isNaN(obj.p_e_ltm) ? 0 : (obj.p_e_ltm).toFixed(2),
                            dividend_yield_ltm: isNaN(obj.dividend_yield_ltm) ? 0 : (obj.dividend_yield_ltm).toFixed(2),
                            p_book_ltm: isNaN(obj.p_book_ltm) ? 0 : (obj.p_book_ltm).toFixed(2),
                            ev_sales_ltm: isNaN(obj.ev_sales_ltm) ? 0 : (obj.ev_sales_ltm).toFixed(2),
                            ev_ebitda_ltm: isNaN(obj.ev_ebitda_ltm) ? 0 : (obj.ev_ebitda_ltm).toFixed(2),
                            p_fcf_ntm: isNaN(obj.p_fcf_ntm) ? 0 : (obj.p_fcf_ntm).toFixed(2),
                            p_e_ntm: isNaN(obj.p_e_ntm) ? 0 : (obj.p_e_ntm).toFixed(2),
                            dividend_yield_ntm: isNaN(obj.dividend_yield_ntm) ? 0 : (obj.dividend_yield_ntm).toFixed(2),
                            p_book_ntm: isNaN(obj.p_book_ntm) ? 0 : (obj.p_book_ntm).toFixed(2),
                            ev_sales_ntm: isNaN(obj.ev_sales_ntm) ? 0 : (obj.ev_sales_ntm).toFixed(2),
                            ev_ebitda_ntm: isNaN(obj.ev_ebitda_ntm) ? 0 : (obj.ev_ebitda_ntm).toFixed(2),
                        })

                        // console.log(doc.id, "2")
                    })
                    this.tableData = list
                }
            )
    }
  }
</script>

<style scoped>

.el-table >>> .green-row {
    background: #ade48f;
}

.el-table >>> .yellow-row {
    background: #ffff007d;
}

.el-table >>> .red-row {
    background: lightcoral;
}

</style>